export const analyticsPage = '/analytics?rows=1000&page=0&filters={}';
export const analyticsPageWithReload = `${analyticsPage}&reload=1`;

export default analyticsPage;
